// Swatch King Customization Script with Hover Effect
document.addEventListener('DOMContentLoaded', function() {
    // Global reference to the selector update functions
    let sizeUpdateFunction = null;
    let comfortUpdateFunction = null;

    // Track current states
    let currentComfortValue = 'balanced';
    let currentSizeIndex = 0;

    let isInitializing = false; // Flag to prevent re-entrant initialization issues

    // Try to initialize both selectors
    let attempts = 0;
    const maxAttempts = 10;

    // Define custom positions for the size selector
    const customSizePositions = {
        4: [15, 38.3333, 61.6666, 85], // For 4 options
        // 3: [20, 50, 80],
        // 5: [10, 30, 50, 70, 90]
    };

    // Define custom positions for the comfort selector's handle and circles
    const comfortHandlePositions = {
        balanced: '25%',
        firm: '75%'
    };
    // The click/drag threshold is 50% of the comfort slider track's width
    const comfortClickThreshold = 50;


    // Add swatch hover effect styles
    if (!document.getElementById('swatch-hover-effect-styles')) {
        const hoverStyle = document.createElement('style');
        hoverStyle.id = 'swatch-hover-effect-styles';
        hoverStyle.textContent = `
      /* Target any swatch group */
      [id*="swatch-group"] .swatch-custom-image {
        position: relative;
      }

      /* Create hover overlay - Default for all */
      [id*="swatch-group"] .swatch-custom-image:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 120px;
        height: 140px;
        background-size: cover;
        background-position: center;
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 6;
        pointer-events: none;
      }

      /* Specific image for Balmoral */
      [id*="swatch-group"] .swatch-custom-image[data-value="Balmoral"]:before {
        background-image: url('https://cdn.shopify.com/s/files/1/0029/7651/4121/files/balmoral-mattress-la-maison-london-2701051.jpg?v=1759756437');
      }

      /* Specific image for Paramount */
      [id*="swatch-group"] .swatch-custom-image[data-value="Paramount"]:before {
        background-image: url('https://cdn.shopify.com/s/files/1/0029/7651/4121/files/Paramount-Explodedview.jpg?v=1751361873');
      }

      /* Specific image for Pocket Deluxe (using Balmoral image for now) */
      [id*="swatch-group"] .swatch-custom-image[data-value="Pocket Deluxe"]:before {
        background-image: url('https://cdn.shopify.com/s/files/1/0029/7651/4121/files/pocket-deluxe-mattress-la-maison-london-1924655.jpg?v=1753123827');
      }

      /* Show the overlay on hover */
      [id*="swatch-group"] .swatch-custom-image:hover:before {
        opacity: 1;
      }

      /* Completely hide the original image div on hover */
      [id*="swatch-group"] .swatch-custom-image:hover .star-set-image > div {
        opacity: 0 !important;
      }

      /* Also target the specific style attribute to ensure complete hiding */
      [id*="swatch-group"] .swatch-custom-image:hover [style*="background-image"] {
        opacity: 0 !important;
        visibility: hidden !important;
      }

      /* Keep text visible */
      [id*="swatch-group"] .swatch-img-text-adjacent,
      [id*="swatch-group"] .swatch-price-adjacent {
        position: relative;
        z-index: 10;
      }
    `;
        document.head.appendChild(hoverStyle);
    }


    const checkSwatchKingInterval = setInterval(() => {
        attempts++;
        if (isInitializing) return;

        const comfortInitialized = initializeComfortSelector();
        const sizeInitialized = initializeSizeSelector();

        if ((comfortInitialized && sizeInitialized) || attempts >= maxAttempts) {
            clearInterval(checkSwatchKingInterval);
            if (comfortUpdateFunction && comfortInitialized) comfortUpdateFunction(currentComfortValue, true);
            if (sizeUpdateFunction && sizeInitialized) sizeUpdateFunction(currentSizeIndex, true);
        }
    }, 250);

    const targetNode = document.body;
    const config = {
        childList: true,
        subtree: true
    };

    const observerCallback = function(mutationsList) {
        if (isInitializing) return;
        const sizeSelectorExists = !!document.querySelector('.custom-size-selector');
        const comfortSelectorExists = !!document.querySelector('.custom-comfort-selector');
        const needsSizeReinit = !sizeSelectorExists && sizeSectionAvailable();
        const needsComfortReinit = !comfortSelectorExists && comfortSectionAvailable();

        if (needsSizeReinit || needsComfortReinit) {
            if (needsSizeReinit) initializeSizeSelector();
            if (needsComfortReinit) initializeComfortSelector();
            setTimeout(() => {
                if (comfortUpdateFunction && document.querySelector('.custom-comfort-selector')) comfortUpdateFunction(currentComfortValue, true);
                if (sizeUpdateFunction && document.querySelector('.custom-size-selector')) sizeUpdateFunction(currentSizeIndex, true);
            }, 100);
        }
    };

    function sizeSectionAvailable() {
        return !!document.querySelector('[option-name="Select Your Size"] .swatch-view-button');
    }

    function comfortSectionAvailable() {
        return !!document.querySelector('[option-name="Select Your Comfort"] .swatch-view-button');
    }

    const observer = new MutationObserver(observerCallback);
    observer.observe(targetNode, config);

    document.addEventListener('variant:changed', function() {
        isInitializing = true;
        observer.disconnect();
        setTimeout(() => {
            initializeSizeSelector();
            initializeComfortSelector();
            setTimeout(() => {
                if (comfortUpdateFunction) comfortUpdateFunction(currentComfortValue, true);
                if (sizeUpdateFunction) sizeUpdateFunction(currentSizeIndex, true);
                isInitializing = false;
                observer.observe(targetNode, config);
            }, 100);
        }, 100);
    });

    function getPositionPercentage(index, totalOptions) {
        const positions = customSizePositions[totalOptions];
        if (positions && positions[index] !== undefined) {
            return positions[index];
        }
        if (totalOptions <= 1) return 50;
        return (index / (totalOptions - 1)) * 100;
    }

    function handleSizeSelection(positionIndex, skipClick = false) {
        const customSizeSelector = document.querySelector('.custom-size-selector');
        const originalSizeSwatchElements = Array.from(
            document.querySelectorAll('[option-name="Select Your Size"] .swatch-view-button .swatch-view-item [data-value]')
        );

        if (customSizeSelector && originalSizeSwatchElements.length > 0) {
            updateCustomSizeUI(positionIndex, customSizeSelector, originalSizeSwatchElements.length);
            if (!skipClick && positionIndex >= 0 && positionIndex < originalSizeSwatchElements.length) {
                const targetOriginalSwatch = originalSizeSwatchElements[positionIndex];
                const item = targetOriginalSwatch.closest('.swatch-view-item');
                if (item && !(item.getAttribute('aria-checked') === 'true' || item.classList.contains('swatch-selected'))) {
                    targetOriginalSwatch.click();
                }
            }
            currentSizeIndex = positionIndex;
        }
    }

    function updateCustomSizeUI(positionIndex, selectorElement, totalOptions) {
        if (!selectorElement || typeof positionIndex === 'undefined') return;

        if (totalOptions === 0) positionIndex = -1;
        else if (positionIndex < 0) positionIndex = 0;
        else if (positionIndex >= totalOptions) positionIndex = totalOptions - 1;

        const percentage = getPositionPercentage(positionIndex, totalOptions);

        const sliderHandle = selectorElement.querySelector('.slider-handle');
        if (sliderHandle) sliderHandle.style.left = `${percentage}%`;

        selectorElement.querySelectorAll('.size-value-container').forEach((container, idx) => {
            const sizeLabel = container.querySelector('.size-label');
            if (sizeLabel) {
                sizeLabel.classList.toggle('selected', idx === positionIndex);
            }
        });

        selectorElement.querySelectorAll('.slider-empty-circle').forEach((circle) => {
            const circleIndex = parseInt(circle.getAttribute('data-circle-index'), 10);
            circle.classList.toggle('hidden', circleIndex === positionIndex);
        });
    }

    function initializeComfortSelector() {
        isInitializing = true;
        const comfortSection = document.querySelector('[option-name="Select Your Comfort"]');
        if (!comfortSection) {
            isInitializing = false;
            return false;
        }

        const comfortSelectorContainer = comfortSection.querySelector('.swatch-view-button');
        if (!comfortSelectorContainer) {
            isInitializing = false;
            return false;
        }

        const balancedOption = comfortSelectorContainer.querySelector('[data-value="Balanced"]');
        const firmOption = comfortSelectorContainer.querySelector('[data-value="Firm"]');
        if (!balancedOption || !firmOption) {
            isInitializing = false;
            return false;
        }

        let existingSelector = comfortSection.querySelector('.custom-comfort-selector');
        if (existingSelector) existingSelector.remove();

        const isBalancedSKSelected = balancedOption.closest('.swatch-view-item').getAttribute('aria-checked') === 'true';
        const determinedComfortValue = isBalancedSKSelected ? 'balanced' : 'firm';
        if (currentComfortValue !== determinedComfortValue || attempts <= 1) {
            currentComfortValue = determinedComfortValue;
        }

        const customSelector = document.createElement('div');
        customSelector.className = 'custom-comfort-selector';

        const initialHandleLeft = comfortHandlePositions[currentComfortValue];
        const balancedCircleLeft = comfortHandlePositions.balanced;
        const firmCircleLeft = comfortHandlePositions.firm;

        customSelector.innerHTML = `
            <div class="comfort-options">
                <span class="comfort-option balanced ${currentComfortValue === 'balanced' ? 'selected' : ''}">Balanced</span>
                <div class="slider-container">
                    <div class="slider-track">
                        <div class="slider-central-tick-element"></div>
                    </div>
                    <div class="slider-handle" data-position="${currentComfortValue}" style="left: ${initialHandleLeft};"></div>
                    <div class="slider-empty-circle balanced ${currentComfortValue === 'balanced' ? 'hidden' : ''}" style="left: ${balancedCircleLeft};"></div>
                    <div class="slider-empty-circle firm ${currentComfortValue === 'firm' ? 'hidden' : ''}" style="left: ${firmCircleLeft};"></div>
                </div>
                <span class="comfort-option firm ${currentComfortValue === 'firm' ? 'selected' : ''}">Firm</span>
            </div>
            <div class="comfort-description">
                <div class="balanced-description" style="display: ${currentComfortValue === 'balanced' ? 'block' : 'none'}; color:#7E8490;">
                    <strong>Balanced:</strong> Offers a gently supportive feel with a touch of softness. Designed to suit a wide range of comfort preferences.
                </div>
                <div class="firm-description" style="display: ${currentComfortValue === 'firm' ? 'block' : 'none'}; color:#7E8490;">
                    <strong>Firm:</strong> Provides a structured, supportive feel with minimal sink. Designed for balanced alignment and lasting comfort.
                </div>
            </div>
        `;

        const fieldset = comfortSelectorContainer.closest('fieldset');
        if (!fieldset) {
            isInitializing = false;
            return false;
        }

        comfortSelectorContainer.style.cssText = 'height: 0; overflow: hidden; margin: 0; padding: 0; opacity: 0; position: absolute; z-index: -1;';
        fieldset.appendChild(customSelector);

        if (!document.getElementById('custom-selector-styles')) {
            const style = document.createElement('style');
            style.id = 'custom-selector-styles';
            style.textContent = `
                /* --- General Wrapper & Titles --- */
                .custom-comfort-selector, .custom-size-selector {
                    font-family: inherit; max-width: 100%; padding: 0;
                }
                fieldset {
                    border: none; padding: 0; margin: 5px 0 35px 0 !important; /* Default margin */
                }
                legend {
                    font-size: 24px; font-weight: 600; color: #333;
                    margin-bottom: 30px; padding: 0; display: block; width: 100%;
                }
                .swatch-label {margin-bottom: 30px !important; margin-top: 40px !important;}
                .swatches-type-products {margin-top: 40px !important;}
                .swatch-option-name {font-size: 25px !important;}
                [id*="swatch-option"], [id*="swatch-group"]{border-bottom: 1px solid #f1ede2;}

                /* Specific spacing for the fieldset containing the size selector */
                /* Assuming the size selector is inside a fieldset with id="swatch-option-dk00-swatch-king-1" or similar */
                /* You might need to adjust this selector if your fieldset ID is different or use a class */
                [option-name="Select Your Size"]fieldset, 
                div[data-option-name="Select Your Size"] fieldset, /* Common Swatch King structures */
                .custom-size-selector-fieldset { /* Add this class to the fieldset in HTML if needed */
                    padding-bottom: 70px !important;
                }
                /* If the above doesn't work, and your fieldsets have specific IDs like "swatch-option1" for size */
                /* fieldset#swatch-option1 { padding-bottom: 70px !important; } */


                /* --- Slider Structure (Common) --- */
                .slider-container {
                    position: relative; height: 20px; cursor: pointer; display: flex; align-items: center;
                }
                .slider-track {
                    position: relative; width: 100%; height: 3px; background-color: #333; border-radius: 0;
                }
                .slider-filled-track { display: none; }

                /* For Comfort Selector - lines at ends and middle */
                .custom-comfort-selector .slider-track::before, .custom-comfort-selector .slider-track::after {
                    content: ''; position: absolute; top: 50%; transform: translateY(-50%);
                    width: 2px; height: 12px; background-color: #333; z-index: 0;
                }
                .custom-comfort-selector .slider-track::before { left: 0px; } /* Tick at the very start of the track */
                .custom-comfort-selector .slider-track::after { right: 0px; } /* Tick at the very end of the track */

                .slider-central-tick-element {
                    position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);
                    width: 2px; height: 12px; background-color: #333; z-index: 0;
                }

                /* For Size Selector - lines at ends ONLY */
                .custom-size-selector .slider-track::before, .custom-size-selector .slider-track::after {
                    content: ''; position: absolute; top: 50%; transform: translateY(-50%);
                    width: 2px; height: 12px; background-color: #333; z-index: 0;
                }
                .custom-size-selector .slider-track::before { left: 0px; }
                .custom-size-selector .slider-track::after { right: 0px; }

                /* --- Comfort Selector Specific Styles --- */
                .custom-comfort-selector .comfort-options {
                    display: flex; align-items: center; justify-content: space-between;
                    margin-bottom: 10px; width: 100%;
                }
                .custom-comfort-selector .comfort-option {
                    font-size: 22px; color: #d4c9a9; font-weight: 400; cursor: pointer;
                    transition: color 0.3s ease, font-weight 0.3s ease;
                    flex-shrink: 0; text-align: center;
                    /* Adjust flex-basis or width as needed to prevent text from overly shrinking the slider */
                     flex-basis: auto; /* Or a percentage like 20% if text is long */
                }
                .custom-comfort-selector .comfort-option.selected { color: #b3a87d; font-weight: 600; }
                .custom-comfort-selector .slider-container {
                    width: 60%; /* Default width, adjust if needed */
                    margin: 0 15px; /* Default margin */
                }

                /* --- Size Selector Specific Styles --- */
                .custom-size-selector .size-slider-container {
                    width: 100%; padding: 0 10px; box-sizing: border-box; margin-bottom:10px;
                }
                .custom-size-selector .slider-track {
                    width: 100%; margin: 0 auto;
                }
                .custom-size-selector .size-options {
                    width: 100%; margin-top: 15px; position: relative; min-height: 50px;
                }
                .custom-size-selector .size-value-container {
                    text-align: center; padding: 0 2px; cursor: pointer;
                    display: flex; flex-direction: column; align-items: center;
                    position: absolute; transform: translateX(-50%);
                }
                .custom-size-selector .size-label {
                    display: block; font-weight: bold; font-size: 16px; color: #333;
                    line-height: 1.3; transition: color 0.3s ease;
                }
                .custom-size-selector .size-label.selected { color: #333; }
                .custom-size-selector .size-dimensions {
                    display: block; font-size: 14px; color: #333; line-height: 1.3;
                }

                /* --- Slider Handle and Empty Circles (Common) --- */
                .slider-handle {
                    position: absolute; top: 50%; width: 20px; height: 20px;
                    background-color: #b3a87d; border-radius: 50%;
                    transform: translate(-50%, -50%); cursor: pointer;
                    transition: left 0.3s ease; z-index: 3; will-change: left;
                }

                .slider-empty-circle {
                    position: absolute; top: 50%; width: 16px; height: 16px;
                    background-color: white; border: 2px solid #333; border-radius: 50%;
                    transform: translate(-50%, -50%); opacity: 1;
                    transition: opacity 0.3s ease; z-index: 2;
                }
                .slider-empty-circle.hidden { opacity: 0; }

                /* --- Descriptions --- */
                .custom-comfort-selector .comfort-description {
                    color: #555; font-size: 16px; line-height: 1.5; margin-top: 15px;
                    padding-bottom: 15px; /* Spacing below the description text */
                }
                .custom-comfort-selector .comfort-description strong { font-weight: bold; color: #333; }

                /* --- Responsive Styles --- */
                @media (max-width: 768px) {
                    legend { font-size: 22px; margin-bottom: 20px;}
                    .custom-comfort-selector .comfort-option { font-size: 20px; }
                    .custom-size-selector .size-label { font-size: 14px; }
                    .custom-size-selector .size-dimensions { font-size: 12px; }
                    .slider-handle { width: 18px; height: 18px; }
                    .slider-empty-circle { width: 14px; height: 14px; }
                    .custom-comfort-selector .slider-track::before, .custom-comfort-selector .slider-track::after, .slider-central-tick-element,
                    .custom-size-selector .slider-track::before, .custom-size-selector .slider-track::after { height: 10px; }
                }
                @media (max-width: 480px) {
                    legend { font-size: 20px; margin-bottom: 15px;}
                    .custom-comfort-selector .comfort-option { font-size: 18px; }
                    .custom-size-selector .size-label { font-size: 12px; }
                    .custom-size-selector .size-dimensions { font-size: 10px; }
                    .slider-handle { width: 16px; height: 16px; }
                    .slider-empty-circle { width: 12px; height: 12px; }
                    .custom-comfort-selector .slider-track::before, .custom-comfort-selector .slider-track::after, .slider-central-tick-element,
                    .custom-size-selector .slider-track::before, .custom-size-selector .slider-track::after { height: 10px; }
                }
            `;
            document.head.appendChild(style);
        }

        const localUpdateComfortUI = function(value, skipClick = false) {
            currentComfortValue = value;
            const elements = {
                handle: customSelector.querySelector('.slider-handle'),
                balDesc: customSelector.querySelector('.balanced-description'),
                firmDesc: customSelector.querySelector('.firm-description'),
                balText: customSelector.querySelector('.comfort-option.balanced'),
                firmText: customSelector.querySelector('.comfort-option.firm'),
                circleBal: customSelector.querySelector('.slider-empty-circle.balanced'),
                circleFirm: customSelector.querySelector('.slider-empty-circle.firm')
            };

            if (!skipClick) {
                if (value === 'balanced' && !balancedOption.closest('.swatch-view-item').classList.contains('swatch-selected')) {
                    balancedOption.click();
                } else if (value === 'firm' && !firmOption.closest('.swatch-view-item').classList.contains('swatch-selected')) {
                    firmOption.click();
                }
            }

            if (elements.handle) {
                elements.handle.style.left = comfortHandlePositions[value];
                elements.handle.setAttribute('data-position', value);
            }
            if (elements.balDesc) elements.balDesc.style.display = value === 'balanced' ? 'block' : 'none';
            if (elements.firmDesc) elements.firmDesc.style.display = value === 'firm' ? 'block' : 'none';
            if (elements.balText) elements.balText.classList.toggle('selected', value === 'balanced');
            if (elements.firmText) elements.firmText.classList.toggle('selected', value === 'firm');

            if (elements.circleBal) elements.circleBal.classList.toggle('hidden', value === 'balanced');
            if (elements.circleFirm) elements.circleFirm.classList.toggle('hidden', value === 'firm');
        };

        comfortUpdateFunction = localUpdateComfortUI;
        const elements = {
            sliderHandle: customSelector.querySelector('.slider-handle'),
            sliderContainer: customSelector.querySelector('.slider-container'),
            balancedText: customSelector.querySelector('.comfort-option.balanced'),
            firmText: customSelector.querySelector('.comfort-option.firm')
        };

        if (elements.sliderContainer) {
            elements.sliderContainer.addEventListener('click', function(e) {
                const rect = this.getBoundingClientRect();
                if (rect.width === 0) return;
                const positionPercentInContainer = ((e.clientX - rect.left) / rect.width) * 100;
                localUpdateComfortUI(positionPercentInContainer < comfortClickThreshold ? 'balanced' : 'firm');
            });
        }

        if (elements.sliderHandle) {
            let isDragging = false;
            elements.sliderHandle.addEventListener('mousedown', function() {
                isDragging = true;
            });
            const handleMouseMove = function(e) {
                if (!isDragging || !document.body.contains(elements.sliderHandle)) {
                    if (isDragging) isDragging = false;
                    return;
                }
                const rect = elements.sliderContainer.getBoundingClientRect();
                if (rect.width === 0) return;
                let positionPercentInContainer = ((e.clientX - rect.left) / rect.width) * 100;
                positionPercentInContainer = Math.max(0, Math.min(100, positionPercentInContainer));
                localUpdateComfortUI(positionPercentInContainer < comfortClickThreshold ? 'balanced' : 'firm', true);
            };
            const handleMouseUp = function(e) {
                if (isDragging) {
                    isDragging = false;
                    if (!document.body.contains(elements.sliderHandle)) return;
                    const rect = elements.sliderContainer.getBoundingClientRect();
                    if (rect.width === 0) return;
                    let positionPercentInContainer = ((e.clientX - rect.left) / rect.width) * 100;
                    positionPercentInContainer = Math.max(0, Math.min(100, positionPercentInContainer));
                    localUpdateComfortUI(positionPercentInContainer < comfortClickThreshold ? 'balanced' : 'firm', false);
                }
            };
            document.addEventListener('mousemove', handleMouseMove, { passive: true });
            document.addEventListener('mouseup', handleMouseUp);
        }
        if (elements.balancedText) elements.balancedText.addEventListener('click', () => localUpdateComfortUI('balanced'));
        if (elements.firmText) elements.firmText.addEventListener('click', () => localUpdateComfortUI('firm'));

        localUpdateComfortUI(currentComfortValue, true);

        isInitializing = false;
        return true;
    }

    function initializeSizeSelector() {
        isInitializing = true;
        const sizeSection = document.querySelector('[option-name="Select Your Size"]');
        if (!sizeSection) { isInitializing = false; return false; }
        const sizeSelectorContainer = sizeSection.querySelector('.swatch-view-button');
        if (!sizeSelectorContainer) { isInitializing = false; return false; }
        const originalSwatchItems = Array.from(sizeSelectorContainer.querySelectorAll('.swatch-view-item'));
        const originalSizeOptions = originalSwatchItems.map(item => item.querySelector('[data-value]')).filter(Boolean);
        if (originalSizeOptions.length === 0) { isInitializing = false; return false; }

        let existingSelector = sizeSection.querySelector('.custom-size-selector');
        if (existingSelector) existingSelector.remove();

        let determinedSizeIndex = -1;
        const sizeData = originalSizeOptions.map((optionEl, index) => {
            const item = optionEl.closest('.swatch-view-item');
            const titleSpan = item.querySelector('.swatch-button-title-text span');
            const fullText = titleSpan ? titleSpan.textContent : optionEl.getAttribute('data-value');
            let sizeName = fullText;
            let dimensions = '';
            const dimensionParseMatch = fullText.match(/^(.*?)\s*-\s*([\d\s]+x\s*[\d\s]+)\s*(cm|inch|inches)/i);
            if (dimensionParseMatch) {
                sizeName = dimensionParseMatch[1].trim();
                dimensions = `${dimensionParseMatch[2].trim()}<br>${dimensionParseMatch[3]}`;
            } else {
                const parts = fullText.split('-');
                sizeName = parts[0] ? parts[0].trim() : fullText;
                if (parts[1]) {
                    dimensions = parts[1].trim().replace(/\s+(cm|inch|inches)$/i, '<br>$1');
                }
            }
            const isSelected = item.getAttribute('aria-checked') === 'true' || item.classList.contains('swatch-selected');
            if (isSelected) determinedSizeIndex = index;
            return {
                element: optionEl,
                isSelected: isSelected,
                value: optionEl.getAttribute('data-value'),
                sizeName: sizeName,
                dimensions: dimensions
            };
        });

        if (determinedSizeIndex !== -1 && (currentSizeIndex !== determinedSizeIndex || attempts <= 1)) {
            currentSizeIndex = determinedSizeIndex;
        } else if (determinedSizeIndex === -1 && originalSizeOptions.length > 0) {
            currentSizeIndex = 0;
        }

        const customSelector = document.createElement('div');
        customSelector.className = 'custom-size-selector with-border';
        let emptyCirclesHTML = '';
        let sizeLabelsHTML = '';
        const totalOptions = sizeData.length;
        if (currentSizeIndex >= totalOptions && totalOptions > 0) currentSizeIndex = 0;
        else if (totalOptions === 0) currentSizeIndex = -1;

        sizeData.forEach((sizeInfo, index) => {
            const positionPercent = getPositionPercentage(index, totalOptions);
            emptyCirclesHTML += `
                <div class="slider-empty-circle size-${index} ${index === currentSizeIndex ? 'hidden':''}" data-circle-index="${index}"
                     style="left: ${positionPercent}%"></div>`;
            sizeLabelsHTML += `
                <div class="size-value-container" data-index="${index}" style="left: ${positionPercent}%">
                    <span class="size-label ${index === currentSizeIndex ? 'selected':''}">${sizeInfo.sizeName}</span>
                    <span class="size-dimensions">${sizeInfo.dimensions}</span>
                </div>`;
        });

        const initialHandlePosPercent = getPositionPercentage(currentSizeIndex, totalOptions);
        customSelector.innerHTML = `
            <div class="slider-container size-slider-container">
                <div class="slider-track"></div>
                <div class="slider-handle" style="left: ${initialHandlePosPercent}%"></div>
                ${emptyCirclesHTML}
            </div>
            <div class="size-options">${sizeLabelsHTML}</div>`;

        const fieldset = sizeSelectorContainer.closest('fieldset');
        if (!fieldset) { isInitializing = false; return false; }

        // Add a specific class to the fieldset for easier CSS targeting for spacing
        fieldset.classList.add('custom-size-selector-fieldset'); // You can use this class in CSS

        sizeSelectorContainer.style.cssText = 'height: 0; overflow: hidden; margin: 0; padding: 0; opacity: 0; position: absolute; z-index: -1;';
        fieldset.appendChild(customSelector);

        sizeUpdateFunction = function(index, skipClickUpdate = false) {
            handleSizeSelection(index, skipClickUpdate);
        };
        const sliderContainer = customSelector.querySelector('.slider-container.size-slider-container');
        const sliderHandle = customSelector.querySelector('.slider-handle');

        if (sliderContainer) {
            sliderContainer.addEventListener('click', function(e) {
                const rect = this.getBoundingClientRect();
                if (rect.width === 0) return;
                const clickXPercent = ((e.clientX - rect.left) / rect.width) * 100;
                let closestIndex = 0;
                let smallestDiff = Infinity;
                const positionsToUse = customSizePositions[totalOptions] || [];
                if (positionsToUse.length > 0 && totalOptions > 0) {
                    for (let i = 0; i < totalOptions; i++) {
                        const posPercent = getPositionPercentage(i, totalOptions);
                        const diff = Math.abs(clickXPercent - posPercent);
                        if (diff < smallestDiff) {
                            smallestDiff = diff;
                            closestIndex = i;
                        }
                    }
                } else if (totalOptions > 0) {
                    closestIndex = Math.round(clickXPercent / 100 * (totalOptions - 1));
                } else {
                    return;
                }
                closestIndex = Math.max(0, Math.min(totalOptions - 1, closestIndex));
                handleSizeSelection(closestIndex);
            });
        }
        if (sliderHandle) {
            let isDragging = false;
            sliderHandle.addEventListener('mousedown', function() { isDragging = true; });
            const handleMouseMove = function(e) {
                if (!isDragging || !document.body.contains(sliderHandle)) {
                    if (isDragging) isDragging = false;
                    return;
                }
                const rect = sliderContainer.getBoundingClientRect();
                if (rect.width === 0) return;
                const moveXPercent = ((e.clientX - rect.left) / rect.width) * 100;
                let closestIndex = 0;
                let smallestDiff = Infinity;
                const positionsToUse = customSizePositions[totalOptions] || [];

                if (positionsToUse.length > 0 && totalOptions > 0) {
                    for (let i = 0; i < totalOptions; i++) {
                        const posPercent = getPositionPercentage(i, totalOptions);
                        const diff = Math.abs(moveXPercent - posPercent);
                        if (diff < smallestDiff) {
                            smallestDiff = diff;
                            closestIndex = i;
                        }
                    }
                } else if (totalOptions > 0) {
                    closestIndex = Math.round(moveXPercent / 100 * (totalOptions - 1));
                } else {
                    return;
                }
                closestIndex = Math.max(0, Math.min(totalOptions - 1, closestIndex));
                updateCustomSizeUI(closestIndex, customSelector, totalOptions);
            };
            const handleMouseUp = function(e) {
                if (isDragging) {
                    isDragging = false;
                    if (!document.body.contains(sliderHandle)) return;
                    const rect = sliderContainer.getBoundingClientRect();
                    if (rect.width === 0) return;
                    const upXPercent = ((e.clientX - rect.left) / rect.width) * 100;
                    let finalIndex = 0;
                    let smallestDiff = Infinity;
                    const positionsToUse = customSizePositions[totalOptions] || [];
                    if (positionsToUse.length > 0 && totalOptions > 0) {
                        for (let i = 0; i < totalOptions; i++) {
                            const posPercent = getPositionPercentage(i, totalOptions);
                            const diff = Math.abs(upXPercent - posPercent);
                            if (diff < smallestDiff) {
                                smallestDiff = diff;
                                finalIndex = i;
                            }
                        }
                    } else if (totalOptions > 0) {
                        finalIndex = Math.round(upXPercent / 100 * (totalOptions - 1));
                    } else {
                        return;
                    }
                    finalIndex = Math.max(0, Math.min(totalOptions - 1, finalIndex));
                    handleSizeSelection(finalIndex);
                }
            };
            document.addEventListener('mousemove', handleMouseMove, { passive: true });
            document.addEventListener('mouseup', handleMouseUp);
        }
        customSelector.querySelector('.size-options').addEventListener('click', function(e) {
            const container = e.target.closest('.size-value-container');
            if (container) {
                const index = parseInt(container.getAttribute('data-index'), 10);
                handleSizeSelection(index);
            }
        });
        updateCustomSizeUI(currentSizeIndex, customSelector, totalOptions);
        isInitializing = false;
        return true;
    }

    function initializeModelSwatchHover() {
        const modelSwatches = document.querySelectorAll('[id*="swatch-group"] .swatch-view-item');
        if (!modelSwatches.length) return;
        // console.log('Model swatch hover effects initialized');
    }
    setTimeout(initializeModelSwatchHover, 500);
    document.addEventListener('variant:changed', function() {
        setTimeout(initializeModelSwatchHover, 300);
    });
});